var map = {
	"./conny-f-stage1-hungry.png": "1dfe",
	"./conny-f-stage2-hungry.png": "e7eb",
	"./conny-f-stage3-hungry.png": "26cb",
	"./conny-f-stage4-hungry.png": "3e02",
	"./conny-f-stage5-hungry.png": "f6d9",
	"./conny-f-stage6-hungry.png": "dc23",
	"./conny-f-stage7-hungry.png": "95df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7fe";